import { render, staticRenderFns } from "./AssetTitle.vue?vue&type=template&id=042a54cd&"
import script from "./AssetTitle.vue?vue&type=script&lang=js&"
export * from "./AssetTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports